import { render, staticRenderFns } from "./SupportButton.vue?vue&type=template&id=55b730b2&scoped=true"
import script from "./SupportButton.vue?vue&type=script&lang=ts"
export * from "./SupportButton.vue?vue&type=script&lang=ts"
import style0 from "./SupportButton.vue?vue&type=style&index=0&id=55b730b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b730b2",
  null
  
)

export default component.exports